import { CURRENCIES, LANGUAGES } from '@savgroup-front-common/constants';

import { ReverseMoney } from './ReverseMoney';

export enum SELLER_ACCOUNT_STATUSES {
  UNKNOWN = 'Unknown',
  LIVE = 'Live',
  CHURNED = 'Churned',
}

export enum SF_SERVICE {
  FIELD_SERVICE_LIGHTNING = 'FieldServiceLightning',
  SERVICE_CLOUD = 'ServiceCloud',
}

export enum SALESFORCE_INTEGRATION_TYPE {
  None = 'None',
  Standard = 'Standard',
  Deprecated = 'Deprecated',
  Integration = 'Integration',
}

export const CARRIER_CONFIGURATION_KEYS = {
  UPS: 'UPS',
  CHRONOPOST: 'Chronopost',
  EXTERNAL: 'External',
  COLISSIMO: 'Colissimo',
  MONDIAL_RELAY: 'MondialRelay',
  DPD: 'DPD',
  SWISS_POST: 'SwissPost',
  TELIAE: 'Teliae',
  WARNING: 'Warning',
  VIR: 'Vir',
  GEODIS: 'Geodis',
  GLS: 'GLS',
  MY_DHL: 'MyDHL',
  DHL_ECOMMERCE: 'DHLEcommerce',
  DHL_PAKET: 'DHLPaket',
} as const;

export type CarrierConfigurationKey =
  (typeof CARRIER_CONFIGURATION_KEYS)[keyof typeof CARRIER_CONFIGURATION_KEYS];

export type CarriersConfiguration<T> = Partial<
  Record<CarrierConfigurationKey, T>
>;

export interface SellerConfiguration {
  automatedMessagesEnabled: boolean;
  isClaimValidationNeeded: boolean;
  insuranceOptIn: {
    threshold: ReverseMoney;
    carriersInsuranceOptIn: CarriersConfiguration<boolean>;
    insuranceOptIn: boolean;
  };
  lowValueThreshold: ReverseMoney;
  hasAgoraConfig?: boolean;
  deductTransportFromRefund: boolean;
  cgvUrl: string;
  ianaTimeZoneName: string;
  acceptedLanguages: LANGUAGES[];
  faqUrl?: string;
  accountManagerConfiguration: {
    sellerId: string;
    accountStatus: SELLER_ACCOUNT_STATUSES;
    customerService: boolean;
    liveDateUtc: string;
    churnDateUtc: string;
    lastChangeTimeUtc: string;
    lastChangeUser: string;
  };
  defaultOwnerOrderUrl: string;
  myAccountUrl: string;
  includedMargin: boolean;
  stripePublishableKey: string;
  ownerNotificationSenderMail: string;
  salesforceFieldServiceLightningIntegrationType: SALESFORCE_INTEGRATION_TYPE;
  salesforceServiceCloudIntegrationType: SALESFORCE_INTEGRATION_TYPE;
  carriersLabelsExpirationDelayInDays?: CarriersConfiguration<number>;
  isCashRegisterConnected: boolean;
  paymentUrl?: string;
  qualiReparUrl?: string;
  shippingBoAuthorizationUrl?: string;
  allowNewFiles: boolean;
  workflowFeatures?: string[];
  vonageNaming?: string;
  currency: CURRENCIES;
}

export type SalesforceSellerConfiguration =
  | {
      integrationType: SALESFORCE_INTEGRATION_TYPE.Standard;
      oAut2AuthorizationServerUrl: string;
      oAut2ConsumerKey: string;
      oAut2DefaultEmail: string;
      oAut2CertificateName: string;
      apiCompositeVersion: string;
      apiCompositeUrlBase: string;
      planificationPolicy: string;
      tokenRequestEndpointUrl: string;
    }
  | {
      integrationType: Extract<
        SALESFORCE_INTEGRATION_TYPE,
        | SALESFORCE_INTEGRATION_TYPE.None
        | SALESFORCE_INTEGRATION_TYPE.Integration
        | SALESFORCE_INTEGRATION_TYPE.Deprecated
      >;
    };
